var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStreamlineQuotation = function SvgStreamlineQuotation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 140"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.083 99.167A5.833 5.833 0 0 1 131.25 105H67.083L43.75 128.333V105h-35a5.833 5.833 0 0 1-5.833-5.833V17.395a5.833 5.833 0 0 1 5.833-5.833h122.5a5.833 5.833 0 0 1 5.833 5.833z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.25 46.562v17.5a11.7 11.7 0 0 1-11.667 11.666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.917 46.562a11.667 11.667 0 1 0 23.333 0 11.667 11.667 0 1 0-23.333 0zm64.166 0v17.5a11.7 11.7 0 0 1-11.666 11.666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.75 46.562a11.667 11.667 0 1 0 23.333 0 11.667 11.667 0 1 0-23.333 0z"
  }))));
};
export default SvgStreamlineQuotation;